// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__36UQ6","vLegacy":"SelectSecondary_vLegacy__2iViD","error":"SelectSecondary_error__2Udz-","disabled":"SelectSecondary_disabled__2Stn_"};